module.exports = __webpack_public_path__ + "img/blog-img.fa0990f3.png";